module.exports = __webpack_public_path__ + "img/sup_kyc_5.ac22862b.jpg";